import { ApiError } from "./util.js";
export const addEmailLoginChallenge = (email, challenge, previous) => ({
    email,
    challenge,
    // A resend may return a decoy. Let the server choose a live ID in one check,
    // so a mistyped code spends only one attempt regardless of resend count.
    previousChallengeIds: previous?.email === email
        ? [previous.challenge.challenge_id, ...previous.previousChallengeIds]
        : [],
});
export const emailErrorMessage = (error) => error instanceof ApiError
    ? error.message
    : "Не удалось связаться с сервером. Проверьте соединение и попробуйте еще раз.";
